import { Typography } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import classes from './ErrorCard.module.scss';

type ErrorCardProps = {
  text: string;
};

export const ErrorCard = ({ text }: ErrorCardProps) => {
  return (
    <div className={classes.errorNotification}>
      <InfoCircleFilled className={classes.infoIcon} />
      <Typography.Text>{text}</Typography.Text>
    </div>
  );
};
